<template>
  <es-drawer-bottom
    navbarStyle="{{navbarStyle}}"
    show="{{showDrawer}}"
    bind:close="close"
    class="main"
  >
    <Content type="{{type}}" />
    <view class="buttons">
      <view bindtap="confirm" class="btn">确认取消</view>
      <view bindtap="close" class="btn">再抢抢看</view>
    </view>
  </es-drawer-bottom>
  <es-popup bind:close="close" show="{{showPopup}}">
    <view class="popup-container">
      <Content type="{{type}}" />
    </view>
  </es-popup>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'

  createComponent({
    props: {
      show: {
        type: Boolean,
        value: false
      },
      type: {
        type: String,
        default: 'popup' // popup中样式较drawer小一些
      }
    },
    computed: {
      showDrawer() {
        return this.show && this.type === 'drawer'
      },
      showPopup() {
        return this.show && this.type === 'popup'
      },
    },
    data: {
      navbarStyle: {
        display: 'none'
      }
    },
    methods: {
      close() {
        this.$trigger('close')
      },
      confirm() {
        this.$trigger('confirm')
      },
    }
  })
</script>

<style lang="stylus" scoped>
  .popup-container
    width 335px
    height 306px
    background #ffffff
    border-radius 16px
  .main
    /deep/ .drawer-container
      height 449px
      overflow auto
      .drawer-main
        padding 0
    .buttons
      @extend .flex-center
      justify-content space-between
      line-height 1
      font-weight normal
      font-family PingFangSC-Regular
      font-size 14px
      color #333333
      padding 0 20px
      .btn
        flex 1
        @extend .flex-center
        justify-content center
        border-radius 8px
        border 1px solid #CCCCCC
        padding 14px 0
        &:last-child
          border 1px solid #FF6400
          background #FF6400
          color #fff
          margin-left 8px
</style>

<script name="json">
  module.exports = {
    component: true,
    usingComponents: {
      'es-drawer-bottom': '@didi/es-mpx-ui/lib/drawer-bottom',
      Content: './content.mpx'
    }
  }
</script>
